import React from "react";

// Data for SVG icons (some marked as dark)
const svgIcons = [
    { name: 'React', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg', link: '/technologies/react' },
    { name: 'Vue.js', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original.svg', link: '/technologies/vue' },
    { name: 'Angular', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg', link: '/technologies/angular' },
    { name: 'HTML5', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg', link: '/technologies/html5' },
    { name: 'CSS3', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg', link: '/technologies/css3' },
    { name: 'JavaScript', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg', link: '/technologies/javascript' },
    { name: 'TypeScript', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg', link: '/technologies/typescript' },
    { name: 'Node.js', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg', link: '/technologies/node' },
    { name: 'Express.js', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg', link: '/technologies/express', dark: true },
    { name: 'Django', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/django/django-plain.svg', link: '/technologies/django', dark: true },
    { name: 'Flask', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flask/flask-original.svg', link: '/technologies/flask', dark: true },
    { name: 'Ruby on Rails', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/rails/rails-original-wordmark.svg', link: '/technologies/rails', dark: true },
    { name: 'Spring Boot', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/spring/spring-original.svg', link: '/technologies/spring' },
    { name: 'MongoDB', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg', link: '/technologies/mongodb' },
    { name: 'Flutter', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg', link: '/technologies/flutter' },
    { name: 'React Native', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg', link: '/technologies/react-native' },
    { name: 'Swift', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/swift/swift-original.svg', link: '/technologies/swift' },
    { name: 'Kotlin', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kotlin/kotlin-original.svg', link: '/technologies/kotlin' },
    { name: 'Java', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg', link: '/technologies/java' },
    { name: 'Docker', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg', link: '/technologies/docker' },
    { name: 'Kubernetes', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg', link: '/technologies/kubernetes', dark: true },
    { name: 'NGINX', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nginx/nginx-original.svg', link: '/technologies/nginx' },
    { name: 'Firebase', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg', link: '/technologies/firebase', dark: true },
];

const   HorizontalSvgScroller = () => {
    return (
        <section
            style={{
                overflow: "hidden",
                padding: 10,
                maskImage:
                    "linear-gradient(to right, rgba(0,0,0,0) 0%, black 10%, black 90%, rgba(0,0,0,0) 100%)",
                WebkitMaskImage:
                    "linear-gradient(to right, rgba(0,0,0,0) 0%, black 10%, black 90%, rgba(0,0,0,0) 100%)",
            }}
        >
            {/* Scroller Track */}
            <ul style={styles.sliderTrack}>
                {svgIcons.map((icon, index) => (
                    <li
                        key={index}
                        title={icon.name}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            minWidth: 60,
                        }}
                    >
                        <img
                            src={icon.icon}
                            alt={icon.name}
                            style={{
                                height: 40,
                                width: 40,
                                objectFit: "contain",
                                backgroundColor: icon.dark ? "#fff" : "transparent",
                                padding: icon.dark ? 4 : 0,
                                borderRadius: 6,
                            }}
                        />
                    </li>
                ))}
            </ul>

            <style>{`
                @keyframes slideLeft {
                    0% {
                        transform: translateX(0);
                    }
                    100% {
                        transform: translateX(-50%);
                    }
                }
            `}</style>
        </section>
    );
};

// CSS for scroller track
const styles = {
    sliderTrack: {
        display: "flex",
        gap: 48,
        width: "max-content",
        animation: "slideLeft 20s linear infinite",
    },
};

export default HorizontalSvgScroller;
